/**
 * @return {string} callback name with random int
 */
export function getCallbackName(name, min, max) {
  let randomInt = Math.floor(Math.random() * (max - min + 1) + min);
  return `${name}_${randomInt}`;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/helpers/callback_name.js
// module id = 552
// module chunks = 1